import axios from "axios";
import decode from "jwt-decode";
import moment from "moment";

const API_URL = process.env.REACT_APP_BASE_URL;
class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/Authenticate/login", {
        username,
        password,
      })
      .then((response) => {
        if (response.data.isSuccess === true) {
          // console.log('test', decode(response.data.token))
          localStorage.setItem("token", JSON.stringify(response.data.token));
          return response;
        } else {
          return response;
        }
      })
      .catch((err) => {
        if (!err.response) {
          return "Network Error";
        } else {
          return err.response;
        }
      });
  }

  logout() {
    localStorage.clear();
    window.location.replace("/login");
  }

  forgotPassword(email) {
    return axios
      .post(API_URL + "/Authenticate/forgetpassword", {
        email,
      })
      .then((response) => {
        console.log("response", response);
        return response;
      })
      .catch(function (error) {
        if (!error.response) {
          return "network Error";
        } else {
          return error.response;
        }
      });
  }
  register(data){
    console.log(data);   
    return axios
    .post(API_URL + "/Authenticate/register", data)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      if (!error.response) {
        return "network Error";
      } else {
        return error.response;
      }
    });
  }
  checkPasswordLink(email, enc1, enc2, enc3) {
    return axios
      .get(API_URL + "api/userlogin/resetPassword_linkexpirycheck", {
        params: {
          email: email,
          enc1: enc1,
          enc2: enc2,
          enc3: enc3,
        },
      })
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        if (!error.response) {
          return "network Error";
        } else {
          return error.response;
        }
      });
  }

  ResetPassword(email, password, confirmPassword,token) {
    return axios
      .post(API_URL + "/Authenticate/ResetPassword", {  
        password,
        confirmPassword,
        email,
        token
      })
      .then((response) => {
        console.log("response", response);
        return response;
      })
      .catch(function (error) {
        if (!error.response) {
          return "network Error";
        } else {
          return error.response;
        }
      });
  }

  isAuthenticateduser() {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined ||
      localStorage.getItem("token") === "undefined"
    ) {
      return false;
    }
    const jwtTkn = localStorage.getItem("token");

    const user = decode(jwtTkn);
    var utcSeconds = user.exp;
    var now = moment().unix();

    if (utcSeconds === null) {
      // console.log("connnnnn")
      localStorage.removeItem("token");
      return true;
    }

    if (utcSeconds >= now) {
      return true;
    } else {
      return false;
    }
  }

  getUserName() {
    // const user = decode(localStorage.getItem("user"));
    const user = decode(localStorage.getItem("token"));
    return user.name;
  }

  getUserID() {
    const user = decode(localStorage.getItem("user"));
    return user.Userid;
  }

  getEmailID() {
    const user = decode(localStorage.getItem("token"));
    // return user.email;
    return user.userID;
  }

  getCurrentserMail(){
    const user = decode(localStorage.getItem("token"));
    return user.email;    
  }
  
  getPhoneNo() {
    const user = decode(localStorage.getItem("token"));
    return user.mobile;
  }

  getCurrentUserRole() {
    const token = localStorage.getItem("token");
    if (token !== undefined && token !== null && token !== "undefined") {
      const userdata = decode(localStorage.getItem("token"));
      return userdata.Roles;
    }
  }

  getCurrentUserReadOnly() {
    const userdata = decode(localStorage.getItem("user"));
    return userdata.Isreadonly;
  }

  getUserUploadImageLimit() {
    const userdata = decode(localStorage.getItem("user"));
    return userdata.Img;
  }

  getTrailPeriodStart() {
    const userdata = decode(localStorage.getItem("user"));
    return userdata.TrailFrom;
  }

  getTrailPeriodEnd() {
    const userdata = decode(localStorage.getItem("user"));
    return userdata.Trail_To;
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }
  getCurrentRefreshToken() {
    return JSON.parse(localStorage.getItem("userRfTkn"));
  }
  getUserprofileData() {
    const user = decode(localStorage.getItem("token"));
    // console.log("user", user)
    return user;
  }

  getLinkToken() {
    var jwt_ex = localStorage.getItem("token");
    var bearer = "Bearer ";
    return  bearer + JSON.parse(jwt_ex);       
  }

  GetmoneyFormat(money) {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    });

    return formatter.format(money);
  }

  GetmoneyFormatInternational(money, code) {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    });

    return formatter.format(money);
  }

  removeuser() {
    localStorage.removeItem("user");
    localStorage.clear();
  }
}

export default new AuthService();
